/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Permonth1Inputs */

const en_permonth1 = /** @type {(inputs: Permonth1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ month`)
};

const de_permonth1 = /** @type {(inputs: Permonth1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/ Monat`)
};

/**
* | output |
* | --- |
* | "/ month" |
*
* @param {Permonth1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const permonth1 = /** @type {((inputs?: Permonth1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Permonth1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_permonth1(inputs)
	return de_permonth1(inputs)
});
export { permonth1 as "perMonth" }